import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Apply theme immediately to avoid flash
const initTheme = () => {
  try {
    const stored = localStorage.getItem('korsordslexikon-theme');
    if (stored) {
      const { colorTheme, darkMode } = JSON.parse(stored);
      const root = document.documentElement;
      
      // Apply color theme
      if (colorTheme && colorTheme !== 'green') {
        root.classList.add(`theme-${colorTheme}`);
      }
      
      const isDark = darkMode === 'dark' || 
        (darkMode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
      if (isDark) {
        root.classList.add('dark');
      }
    }
  } catch {
    // Ignore errors
  }
};

initTheme();

createRoot(document.getElementById("root")!).render(<App />);
